<template>
    <div class="card-container">
        <ui-card :dynamicIcon="iconName" title="Séries">
            <template #body>
                <div class="area-card">
                    <div class="internal-header">
                        <h2 class="title">Labels das Séries</h2>
                        <span class="desc">Personalize os labels das séries para que a visualização dos recursos e
                            funcionalidades do sistema estejam em conformidade com seus processos de vendas
                            atuais.</span>
                    </div>
                    <div class="restore-series-button-container" v-if="!loading && $mx_userIsAdmin">
                        <button class="restore-series-button" @click="resetAllSeries">Restaurar nome de todas as
                            séries</button>
                    </div>
                    <div class="table">
                        <ui-table name="proposal-series-names" :data="form" :columns="tableColumns"
                            not-found-icon="fa fa-file-contract"
                            not-found-text="Não foi possível encontrar nenhuma parcela" :select-column-menu="false"
                            tr-component="configurations/series-table-line" :loading="loading" :lastColFixed="false" />
                    </div>
                    <div class="warining-text">
                        <p>A alteração dos <span>labels</span> das parcelas <span>não impactará contratos</span>,
                            simulações ou relatórios antigos. Os documentos anteriores manterão os nomes originais
                            registrados no momento da criação.</p>
                    </div>
                </div>
            </template>
            <template #fr v-if="$mx_userIsAdmin">
                <ui-button design="md success" :disabled="loading || !hasFormChanged"
                    @click="submitSeries">
                    <ui-load-indicator v-if="loading && hasFormChanged" :h="15" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
                    {{loading && hasFormChanged ? 'Salvando' : 'Salvar'}}
                </ui-button>
            </template>
        </ui-card>
    </div>

</template>

<script>
import { uiCardToggle, uiCard } from '@/components/ui/cards';
import { uiTable, uiLoadIndicator } from '@/components/ui';
import { storage } from '@/services/storage';
import { uiInput } from '@/components/ui/form';
import { uiButton } from '@/components/ui/buttons';
import { salesTable } from '@/services/axios';
import { permissionsMixin, formMixin } from '@/mixins'

export default {
    name: 'proposal-series-names',

    components: {
        uiCardToggle,
        uiTable,
        uiButton,
        uiInput,
        uiCard,
        uiLoadIndicator
    },
    mixins: [formMixin, permissionsMixin],

    created() {
        this.getSeries()
        this.$root.$on('update-name', (data) => {
            this.updateName(data)
        })
        this.$root.$on('restore-name', (data) => {
            this.form = this.form.map((item) => {
                if (item.parcel_type === data) {
                    item.display_name = this.defaultSeries[data].type
                }
                return item
            })

        })
    },
    beforeDestroy() {
        this.$root.$off('update-name')
    },
    data() {
        return {
            isUserAdmin: JSON.parse(storage.get('user_logged')).user_group === 'admin',
            form: {},
            oldForm: {},
            loading: false,
            iconName: 'ui-sales-series',
            defaultSeries: {
                yearly: { type: 'Anual', desc: 'Pagamento único feito uma vez ao ano, geralmente associado a contratos de longa duração.' },
                bimonthly: { type: 'Bimestral', desc: 'Pagamento recorrente a cada dois meses, utilizado em contratos que exigem menor frequência de cobrança.' },
                semester: { type: 'Semestral', desc: 'Pagamento realizado duas vezes ao ano, facilitando o planejamento financeiro.' },
                quarterly: { type: 'Trimestral', desc: 'Cobrança feita a cada três meses, podendo ser utilizada em planos mais espaçados.' },
                four_monthly: { type: 'Quadrimestral', desc: 'Pagamento que ocorre a cada quatro meses, comum em planos de médio prazo.' },
                monthly: { type: 'Mensal', desc: 'Pagamento recorrente a cada mês, seguindo um cronograma preestabelecido.' },
                keys: { type: 'Chaves', desc: 'Pagamento atrelado à entrega do imóvel ou bem adquirido, representando um marco no contrato.' },
                act: { type: 'Ato', desc: 'Representa um pagamento realizado no momento da assinatura do contrato ou formalização do compromisso.' },
                unique: { type: 'Única', desc: 'Pagamento realizado de uma única vez, sem parcelamentos ou recorrências.' },
                signal: { type: 'Entrada', desc: 'Valor pago antecipadamente como parte do pagamento total, geralmente representando uma fração significativa do montante' },
                bonus: { type: 'Bonificação', desc: 'Valor concedido como benefício ou incentivo, podendo ser aplicado como desconto ou crédito adicional.' },
                fgts_config: { type: 'FGTS', desc: 'Uso do saldo do Fundo de Garantia do Tempo de Serviço como forma de pagamento ou amortização de dívida.' },
                fgts: { type: 'FGTS', desc: 'Uso do saldo do Fundo de Garantia do Tempo de Serviço como forma de pagamento ou amortização de dívida.' },
                allowance_config: { type: 'Subsídio', desc: 'Benefício financeiro concedido por terceiros (governo, empresas ou programas sociais) para auxiliar no pagamento.' },
                allowance: { type: 'Subsídio', desc: 'Benefício financeiro concedido por terceiros (governo, empresas ou programas sociais) para auxiliar no pagamento.' },
                financing_config: { type: 'Financiamento', desc: 'Valor pago de forma parcelada por meio de um contrato de crédito, geralmente mediado por uma instituição financeira.' },
                financing: { type: 'Financiamento', desc: 'Valor pago de forma parcelada por meio de um contrato de crédito, geralmente mediado por uma instituição financeira.' },
                intermediary: { type: 'Intermediária', desc: 'Parcela ou pagamento que ocorre entre dois eventos financeiros principais, funcionando como um ajuste no fluxo de pagamento.' },
                assets_rights: { type: 'Bens e Direitos', desc: 'Forma de pagamento ou liquidação feita por meio da transferência de um bem ou direito em vez de dinheiro.' },
                fixed_value: { type: 'Valor Fixo', desc: 'Parcela ou pagamento que mantém o mesmo valor ao longo do período acordado, sem reajustes ou variações.' }
            },
            tableColumns: [
                {
                    title: 'Série',
                    size: '200'
                },
                {
                    title: 'Original'
                },
                {
                    title: 'Descrição',
                    size: '300'
                },
                {
                    title: '',
                    size: '30'
                }
            ]
        }
    },
    methods: {
        resetAllSeries() {
            this.form = this.form.map((item) => {
                item.display_name = this.defaultSeries[item.parcel_type].type
                return item
            })
        },
        submitSeries() {
            this.loading = true;
            salesTable.updateSeries({ 'parcel_types': this.form }).then(() => {
                this.$mx_copyOldForm()
                this.$toastr.s('Séries atualizadas com sucesso')
            }).catch(e => {
                this.$toastr.e(e?.data?.msg || 'Erro ao atualizar séries.')
            }).finally(() => {
                this.loading = false;
                this.$mx_copyOldForm()
            });
        },
        updateName(data) {
            this.form = this.form.map((item) => {
                if (item.id === data.id) {
                    item.display_name = data.display_name
                }
                return item
            })
        },
        getSeries() {
            this.loading = true;
            salesTable.getSeries().then((response) => {
                this.form = response.data
            }).catch((error) => {
                this.$toastr.e(error)
            }).finally(() => {
                this.loading = false;
                this.$mx_copyOldForm()
            });
        },
    },
    computed: {
        hasFormChanged() {
            return JSON.stringify(this.form) !== JSON.stringify(this.oldForm)
        },
    }


}
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>